import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { BusinessPriceTierDeleteCard } from './components/PriceTierDeleteCard';
import { BusinessPriceTierDetailsCard } from './components/PriceTierDetailsCard';

export function BusinessPriceTierDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const businessPriceTierQueryResults = useQuery({
        queryKey: ['businessPriceTier', id],
        queryFn: () => Api.BusinessSpecific.PriceTier.getPriceTier(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={businessPriceTierQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <BusinessPriceTierDetailsCard
                            businessPriceTier={data}
                        />

                        <Can I="delete" a="BusinessPriceTier">
                            <BusinessPriceTierDeleteCard
                                businessPriceTier={data}
                            />
                        </Can>
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
